<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'leads.list.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <form [formGroup]="filterForm" class="filter-form">
        <formly-form [form]="filterForm" [fields]="filterFields" [model]="filterModel" />
      </form>

      @if (filteredLeads().length === 0) {
        <p class="empty-state" data-testid="leads-empty">{{ 'leads.list.empty' | translate }}</p>
      } @else {
        <ul class="lead-list" data-testid="lead-list">
          @for (lead of filteredLeads(); track lead.id) {
            <li class="lead-row" [attr.data-testid]="'lead-row-' + lead.id">
              <button type="button" class="lead-row-button flex flex-align-center flex-justify-space-between gap-sm" (click)="openLead(lead)">
                <div class="flex flex-column">
                  <span class="lead-contact">{{ lead.contact_name || ('leads.list.noContactName' | translate) }}</span>
                  <span class="lead-address">{{ addressLabel(lead) }}</span>
                </div>
                <div class="flex flex-align-center gap-sm">
                  @if (lead.estimated_value) {
                    <span class="lead-value">{{ lead.estimated_value.toFixed(2) }} {{ lead.currency }}</span>
                  }
                  <span class="lead-assignee">{{ assigneeName(lead) }}</span>
                  <app-lead-stage-chip [stage]="lead.stage" />
                </div>
              </button>
            </li>
          }
        </ul>
      }
    </app-card-content>
    <app-card-actions>
      <app-button variant="outlined" (click)="exportCsv()" data-testid="export-leads-csv-button">
        <app-icon name="download" [size]="16" />
        {{ 'leads.list.exportCsv' | translate }}
      </app-button>
      <app-button variant="outlined" (click)="exportXlsx()" data-testid="export-leads-xlsx-button">
        <app-icon name="download" [size]="16" />
        {{ 'leads.list.exportXlsx' | translate }}
      </app-button>
    </app-card-actions>
  </app-card>
</div>
